import script from "./CreateAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAccount.vue?vue&type=script&setup=true&lang=js"

import "./CreateAccount.vue?vue&type=style&index=0&id=dfff4718&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfff4718"]])

export default __exports__